// client/src/pages/Admin/ResourceManager/components/BulkActionToolbar.tsx

import React from 'react';
import {
  CheckSquare,
  CheckCircle2,
  Archive,
  Star as StarIcon,
  StarOff,
  FileSpreadsheet,
  Trash2,
  X
} from 'lucide-react';

interface BulkActionToolbarProps {
  selectedCount: number;
  isBulkActionLoading: boolean;
  onPublish: () => void;
  onArchive: () => void;
  onFeature: () => void;
  onUnfeature: () => void;
  onExport: () => void;
  onDelete: () => void;
  onClear: () => void;
}

export const BulkActionToolbar: React.FC<BulkActionToolbarProps> = ({
  selectedCount,
  isBulkActionLoading,
  onPublish,
  onArchive,
  onFeature,
  onUnfeature,
  onExport,
  onDelete,
  onClear
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bulk-actions-bar">
      <div className="bulk-actions-left">
        <CheckSquare size={16} />
        <span className="bulk-selected-count">
          {selectedCount} resource{selectedCount !== 1 ? 's' : ''} selected
        </span>
      </div>
      <div className="bulk-actions-right">
        <button
          type="button"
          className="bulk-action-btn"
          onClick={onPublish}
          disabled={isBulkActionLoading}
        >
          <CheckCircle2 size={14} />
          Publish
        </button>
        <button
          type="button"
          className="bulk-action-btn"
          onClick={onArchive}
          disabled={isBulkActionLoading}
        >
          <Archive size={14} />
          Archive
        </button>
        <button
          type="button"
          className="bulk-action-btn bulk-action-feature"
          onClick={onFeature}
          disabled={isBulkActionLoading}
        >
          <StarIcon size={14} />
          Feature
        </button>
        <button
          type="button"
          className="bulk-action-btn bulk-action-unfeature"
          onClick={onUnfeature}
          disabled={isBulkActionLoading}
        >
          <StarOff size={14} />
          Unfeature
        </button>
        <button
          type="button"
          className="bulk-action-btn bulk-action-export"
          onClick={onExport}
          disabled={isBulkActionLoading}
        >
          <FileSpreadsheet size={14} />
          Export
        </button>
        <button
          type="button"
          className="bulk-action-btn bulk-action-delete"
          onClick={onDelete}
          disabled={isBulkActionLoading}
        >
          <Trash2 size={14} />
          Delete
        </button>
        <button
          type="button"
          className="bulk-action-btn bulk-action-clear"
          onClick={onClear}
          disabled={isBulkActionLoading}
        >
          <X size={14} />
          Clear
        </button>
      </div>
    </div>
  );
};